import { create } from "zustand"

export interface AuthUser {
  id: number
  fullName: string
  superuser: boolean
  permissions: string[]
}

interface AuthState {
  user: AuthUser | null
  isAuthenticated: boolean
  setUser: (user: AuthUser | null) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  setUser: (user) => set({ user, isAuthenticated: user !== null }),
  clear: () => set({ user: null, isAuthenticated: false }),
}))

/**
 * True when the authenticated user has the given permission code OR is a superuser.
 * Use for conditional UI rendering. Backend enforces the same rule via @PreAuthorize.
 */
export function usePermission(code: string): boolean {
  return useAuthStore((s) => {
    if (!s.user) return false
    if (s.user.superuser) return true
    return s.user.permissions.includes(code)
  })
}
